/**
 * The website widget (public/widget.js) shows the chat in an iframe on the hotel's own site, at /embed.
 */

/** Whether the chat runs inside the widget's iframe rather than as its own page. */
export const isEmbedded = (() => {
   try {
      return window.self !== window.top;
   } catch {
      return true;
   }
})();

/** Asks the widget on the hotel's page to close the chat panel. */
export const closeEmbeddedChat = (): void => {
   window.parent.postMessage({ type: 'xenioai:close' }, '*');
};
